import { Grid, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { Redirect } from 'react-router-dom';
import {
    Button,
    InputText,
    Form,
    FormControl,
    Snackbar,
    VSpacer
} from 'sm-react-components';
import mixpanel, { Events as MPEvents } from '../../infrastructure/mixpanel';
import * as routes from '../../infrastructure/routemap';
import {
    getNewPasswordValidate,
    getResetPassword,
    postNewPassword
} from '../../infrastructure/requests';
import Link from '../components/Link';

const styles = theme => ({
    field: {
        width: '100%'
    },
    snackbarRoot: {
        top: '-10%'
    }
});

class ResetPasswordContainer extends React.Component {
  state = {
      email: '',
      password: '',
      password2: '',
      error: undefined,
      ready: false,
      success: false,
      tokenValid: false,
      openSnack: false
  };

  validateToken = async token => {
      try {
          await getNewPasswordValidate(token);
          mixpanel.track(MPEvents.USER_VALIDATE_NEW_PASSWORD_TOKEN);
          this.setState({ tokenValid: true });
      } catch (exception) {
          this.setState({ error: exception.message, openSnack: true });
      }
  };

  componentDidMount() {
      this.props.token && this.validateToken(this.props.token);
  }

  handleResetPassword = async () => {
      const { email } = this.state;
      try {
          await getResetPassword(email);
          mixpanel.track(MPEvents.USER_RESET_PASSWORD, { email });
          this.setState({ success: true });
      } catch (error) {
          this.setState({ error: error.message, openSnack: true });
      }
  };

  handleNewPassword = async () => {
      const { token } = this.props;
      const { password } = this.state;
      try {
          await postNewPassword(token, password);
          mixpanel.track(MPEvents.USER_CREATE_NEW_PASSWORD);
          this.setState({ success: true });
      } catch (error) {
          this.setState({ error: error.message, openSnack: true });
      }
  };

  handleEmailChange = email => {
      this.setState({ email });
  };

  handlePasswordChange = password => {
      this.setState({ password });
  };

  handlePassword2Change = password2 => {
      this.setState({ password2 });
  };

  resetrequest = () => {
      const { classes } = this.props;
      const { email, success } = this.state;
      return (
          <React.Fragment>
              {!success && (
                  <Form
                      direction="column"
                      onSubmit={this.handleResetPassword}
                      lazyValidation
                  >
                      <Typography>
              Write down the registered email address. An email will be sent
              with the instructions to reset your password.
                      </Typography>

                      <VSpacer />
                      <InputText
                          className={classes.field}
                          id="email"
                          type="email"
                          label="Email"
                          value={email}
                          onChange={mail => this.handleEmailChange(mail)}
                          margin="normal"
                          style={{ width: '100%' }}
                          validators={['required', 'email']}
                      />

                      <VSpacer />
                      <FormControl justify="center">
                          <Button type="submit">Send mail</Button>
                      </FormControl>
                      <VSpacer />
                  </Form>
              )}
              {success && (
                  <React.Fragment>
                      <Typography>
              An email has been sent to your account. Review your inbox and
              follow the instructions.
                      </Typography>
                  </React.Fragment>
              )}
          </React.Fragment>
      );
  };

  resetform = () => {
      const { classes } = this.props;
      const { password, password2, tokenValid, success } = this.state;
      return (
          <React.Fragment>
              {success && <Redirect to={routes.login} />}

              {tokenValid && !success && (
                  <Form
                      onSubmit={this.handleNewPassword}
                      lazyValidation
                      direction="column"
                  >
                      <InputText
                          className={classes.field}
                          id="password"
                          type="password"
                          label="Password"
                          value={password}
                          onChange={mail => this.handlePasswordChange(mail)}
                          margin="none"
                          validators={['required']}
                      ></InputText>
                      <InputText
                          className={classes.field}
                          id="password2"
                          type="password"
                          label="Confirm Password"
                          value={password2}
                          onChange={mail => this.handlePassword2Change(mail)}
                          margin="none"
                          customValidator={() =>
                              password !== password2 ? 'Passwords must match' : undefined
                          }
                      ></InputText>
                      <VSpacer />
                      <FormControl justify="center">
                          <Button type="submit">Reset Password</Button>
                      </FormControl>
                  </Form>
              )}
              {!tokenValid && (
                  <Typography>
            The token is invalid or has expired. Try it again.
                  </Typography>
              )}
          </React.Fragment>
      );
  };

  render() {
      const { classes, token } = this.props;
      const { error, openSnack } = this.state;
      return (
          <React.Fragment>
              <Snackbar
                  variant={'error'}
                  open={openSnack}
                  onClose={() => this.setState({ openSnack: false })}
                  autoHideDuration={3000}
                  closeByClickAway
                  horizontal="center"
                  vertical="top"
                  message={error}
                  classes={{ anchorOriginTopCenter: classes.snackbarRoot }}
              />
              <Grid
                  container
                  style={{ height: '100%' }}
                  justify="space-between"
                  direction="column"
              >
                  <Grid item>
                      <Typography variant="h5">Reset Password</Typography>
                  </Grid>

                  {!token ? this.resetrequest() : this.resetform()}

                  <Grid item>
                      <Typography component="span">
                          <Link to={routes.register}>Register</Link>
                      </Typography>
                  </Grid>
              </Grid>
          </React.Fragment>
      );
  }
}

export default withStyles(styles)(ResetPasswordContainer);
